import React, { useState } from "react";
import { Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { withTranslation } from 'react-i18next';


const AlertModal = ({ t, display, selection }) => {
    const [modalBackdrop, setModalBackdrop] = useState(true);

    const toggleBackdrop = () => {
        selection(false);
        // setModalBackdrop(!modalBackdrop);
        removeBodyCss();
    };

    const handleYes = () => {
        selection(true);
        // setModalBackdrop(!modalBackdrop);
        removeBodyCss();
    };

    const removeBodyCss = () => {
        // Implement your removeBodyCss function logic here
    };

    return (
        <Col sm={6} md={4} xl={3}>
            <Modal isOpen={modalBackdrop} toggle={toggleBackdrop} id="staticBackdrop" backdrop={false}>
                <ModalHeader className="mt-0" toggle={toggleBackdrop}>{t("Delete")}</ModalHeader>
                <ModalBody>
                    <p>{t("AreyouSureyouwanttoDelete")}</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={toggleBackdrop}>{t("Close")}</Button>{' '}
                    <Button color="danger" onClick={handleYes}>{t("Yes")}</Button>
                </ModalFooter>
            </Modal>
        </Col>
    );
};

export default withTranslation()(AlertModal);

